module.exports = __webpack_public_path__ + "static/media/world.3e23f5dc.svg";